<template>
  <div class="base-box">
    <!-- 附件上传 -->
    <h3>
      <van-icon name="upgrade" color="#228ccd" />附件上传
    </h3>
    <p class="warm">注：文件大小不超过6M，支持 jpg 和 png 格式；</p>
    <div class="base-item">
      <h4>加盖公章的营业执照复印件</h4>
      <van-uploader
        v-model="fileList"
        :after-read="afterLicenceFileId"
        @delete="delFile('licenceFileId')"
        :max-count="1"
      />
    </div>
    <div class="base-item">
      <h4>公司logo</h4>
      <van-uploader
        v-model="fileList2"
        :after-read="afterPortraitFile"
        @delete="delFile('portraitId')"
        :max-count="1"
      />
    </div>
    <!-- 基本信息 -->
    <h3>
      <van-icon name="orders-o" color="#228ccd" />基本信息
    </h3>
    <div class="base-item">
      <van-field
        class="input-item"
        label="单位会员名称"
        v-model="params.name"
        required
        clearable
        placeholder="请输入单位会员名称"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        label="法定代表人姓名"
        v-model="params.corporation"
        clearable
        placeholder="请输入法定代表人姓名"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        label="从事声学工作的科技人员数"
        v-model="params.researcherCount"
        required
        clearable
        placeholder="请输入人员数"
      />
    </div>

    <div class="base-item">
      <van-cell
        class="input-item"
        title="加入分会或总会"
        :value="getName('branchsList','recommendUnitId')"
        is-link
        @click="setSelectModel('branchsList','name','recommendUnitId')"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        type="textarea"
        v-model="params.fullAddress"
        required
        clearable
        placeholder="请输入详细地址"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        type="textarea"
        v-model="params.website"
        required
        clearable
        placeholder="请输入您的公司网址"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        type="textarea"
        v-model="params.introduction"
        clearable
        placeholder="请输入单位简介（主要进行哪些科研、生产、教学工作）"
      />
    </div>
    <div class="base-item">
      <van-field
        class="input-item"
        type="textarea"
        v-model="params.awards"
        clearable
        placeholder="请输入单位主要荣誉"
      />
    </div>
    <van-button class="nextBtn" type="primary" size="large" @click="next">下一步</van-button>

    <!-- 选择弹窗 -->
    <van-popup v-model="selectModel" position="bottom" :style="{ 'min-height': '20%' }">
      <van-picker
        show-toolbar
        ref="picker"
        :value-key="key"
        :columns="columns"
        @change="onChange"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Uploader,
  Field,
  Cell,
  CellGroup,
  Button,
  Popup,
  Picker,
  Toast
} from "vant";
import { mapState, mapGetters, mapActions } from "vuex";
import { uploadFile, delFile } from "@/api/upload";
import { registerGroupEdit } from "@/api/login";
import axios from "axios";

export default {
  data() {
    return {
      fileList: [],
      fileList2: [],
      selectModel: false,
      params: {
        name: "",
        corporation: "",
        researcherCount: "",
        recommendUnitId: null,
        licenceFileId: null,
        portraitId: null,
        website: "",
        introduction: "",
        awards: "",
        fullAddress: ""
      },
      key: "", //选择弹窗显示对应的参数名
      selectKey: "", //所选择的字段
      titleGroup: "", //职称第一列的数据
      jgName: "",
      addName: "",
      columns: [],
      request: {
        licenceFileId: "请上传加盖公章的营业执照复印件",
        portraitId: "请上传公司LOGO",
        name: "请输入单位会员名称",
        corporation: "请输入法人名称",
        researcherCount: "请输入单位科技人员总数",
        website: "请输入公司网址",
        introduction: "请输入单位简介",
        fullAddress: "请输入详细地址",
      }
    };
  },
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Uploader.name]: Uploader,
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },
  watch: {
    "params.birthday"(date) {
      console.log(date);
    }
  },
  props: {
    member: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["branchsList"])
  },
  methods: {
    ...mapActions(["getBranchsList"]),
    afterLicenceFileId(fileObj) {
      let params = new FormData();
      params.append("file", fileObj.file);
      uploadFile(params).then(res => {
        if (res.success) {
          this.params.licenceFileId = res.result.id;
          Toast("上传成功");
        } else {
          Toast("删除失败");
        }
      }).catch(() => {
        //失败
      });
    },
    afterPortraitFile(fileObj) {
      let params = new FormData();
      params.append("file", fileObj.file);
      uploadFile(params).then(res => {
        if (res.success) {
          this.params.portraitId = res.result.id;
          Toast("上传成功");
        } else {
          Toast("删除失败");
        }
      });
    },
    delFile(type) {
      let id = this.params[type];
      if (id) {
        let params = {
          id
        };

        delFile(params).then(res => {
          if (res.success) {
            Toast("删除成功");
          } else {
            Toast("删除失败");
          }
        });
      }
    },
    getName(list, type) {
      let id = this.params[type];

      if (!id && id !== 0) {
        return "内容";
      } else {
        let obj = null;

        if (type === "recommendUnitId" || type === "concernUnitId") {
          obj = this[list].find(item => item.id === id);
        } else if (type === "title") {
          let group = this[list].find(item => item.value === this.titleGroup);
          let obj = group.children.find(item => item.value === id);

          return obj.label;
        } else {
          obj = this[list].find(item => item.value === id);
        }
        return obj.name;
      }
    },
    setSelectModel(type, key, selectKey, ismore) {
      this.selectModel = true;
      this.key = key;
      this.selectKey = selectKey;

      //是否多级
      if (ismore) {
        this.columns = [
          {
            values: this[type],
            className: "column1"
          },
          {
            values: this[type][0].children,
            className: "column2"
          }
        ];
      } else {
        this.columns = this[type];
      }
    },
    onChange(picker, values, index) {
      if (this.selectKey === "title") {
        picker.setColumnValues(1, values[0].children);
      } else if (this.selectKey === "jg" || this.selectKey === "add") {
        let city = this.cityList.filter(item => {
          return item.parentId === values[0].id;
        });
        if (index === 0) {
          picker.setColumnValues(1, city);
        }
      }
    },
    onConfirm(item) {
      this.selectModel = false;
      if (
        this.selectKey === "recommendUnitId" ||
        this.selectKey === "concernUnitId"
      ) {
        this.params[this.selectKey] = item.id;
      } else {
        this.params[this.selectKey] = item.value;
      }
    },
    onCancel() {
      this.selectModel = false;
    },
    onConfirmDate(time) {
      this.params.birthday = time;
      this.selectModel = false;
    },
    next() {
      let params = {
        ...this.member,
        ...this.params
      };

      for (let item in this.request) {
        if (!this.params[item] || !("" + this.params[item]).length) {
          Toast(this.request[item]);
          return;
        }
      }

      Toast.loading({
        mask: true,
        duration: 0,
        message: "加载中..."
      });

      registerGroupEdit(params)
        .then(res => {
          if (res) {
            this.$emit("sendActive", 2);
          } else {
            Toast(res.message || "操作失败");
          }
        })
        .catch(res => {
          Toast.error("操作失败!");
        })
        .finally(() => {
          Toast.clear();
        });
    }
  },
  mounted() {
    this.getBranchsList();
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="less" scoped>
h3 {
  display: flex;
  margin-top: 25px;
  font-size: 16px;
  align-items: center;
  i {
    margin-right: 6px;
  }
}
h4 {
  font-size: 14px;
  line-height: 2;
  span {
    display: inline-block;
    margin-left: 10px;
    color: #d64a4a;
  }
}
.base-item {
  margin-top: 10px;
}
.input-item {
  padding: 0 0 0 0.35rem;
  padding-bottom: 12px;
  border-bottom: 1px solid #dfdfdf;
}
.warm {
  margin-top: 3px;
  color: #d64a4a;
  font-size: 12px;
}
.nextBtn {
  margin-top: 35px;
}
</style>
